import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKeycdnComponent } from './simple-icons-keycdn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKeycdnComponent ],
    exports:      [ SimpleIconsKeycdnComponent ],
    bootstrap:    []
})
export class SimpleIconsKeycdnModule {}
